var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec11Cardimg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 60,
    viewBox: "0 0 58 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1899 17.6364V2.00466C46.1899 2.00209 46.1878 2 46.1852 2H2.00466C2.00209 2 2 2.00209 2 2.00466V57.7425C2 57.7451 2.00209 57.7472 2.00466 57.7472H46.1852C46.1878 57.7472 46.1899 57.7451 46.1899 57.7425V46.8697M30.5534 51.6286H22.3953M30.5534 45.51H12.8775M12.8775 38.7116H30.5534M30.5534 32.593H12.8775M17.0929 23.755C15.7339 22.0839 14.917 19.9369 14.917 17.6364C14.917 12.3799 19.1819 7.92404 24.4348 8.1186C29.5037 8.30633 33.2728 12.5641 33.2728 17.6364C33.2728 19.9477 32.4902 22.09 31.1586 23.755M17.0929 23.755C18.8392 25.9023 21.4808 27.2636 24.4348 27.1542C27.1939 27.052 29.5679 25.744 31.1586 23.755M17.0929 23.755C16.9566 21.0356 21.0356 19.6759 24.4348 19.6759M24.4348 19.6759C27.591 19.3416 31.2333 21.0356 31.1586 23.755M24.4348 19.6759C23.0752 19.6759 21.0356 18.9961 21.0356 16.9566C21.0356 14.917 22.3953 13.5573 24.4348 13.5573C26.4744 13.5573 27.1542 15.5969 27.1542 16.9566C27.1542 18.3163 26.4744 19.6759 24.4348 19.6759Z",
    stroke: "#102C57",
    strokeWidth: 2.71938
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3124 42.7906L40.7511 46.1899M35.3124 42.7906L34.6334 51.6171C34.6331 51.6213 34.638 51.6237 34.6411 51.6209L40.7511 46.1899M35.3124 42.7906L47.5495 21.0356M40.7511 46.1899L53.6681 25.1147M47.5495 21.0356L53.6681 25.1147M47.5495 21.0356C47.5495 21.0356 50.2689 14.2372 54.348 16.2767C58.427 18.3163 53.6681 25.1147 53.6681 25.1147",
    stroke: "#102C57",
    strokeWidth: 2.71938
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec11Cardimg3);
export default __webpack_public_path__ + "static/media/sec11cardimg3.dcca8bc00312742a550a9f219401f1c4.svg";
export { ForwardRef as ReactComponent };